import {
  GUARANTY_DESCRIPTION,
  LIQUIDITY_DESCRIPTION,
  MACHINE_DESCRIPTION,
  OFFICE_EQUIPMENT_DESCRIPTION,
  REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION,
  VEHICLE_DESCRIPTION,
} from 'modules/Inquiry/Form/formFields';

/**
 * ECBFS-2: the Beschreibung fields of the BfS lane, one per purpose the lane offers
 * (see `usePurposeKindOptions`). All of them are capped at `BFS_MAX_DESCRIPTION_LENGTH`.
 *
 * Kept in one place because three things have to agree on the same set: the Joi cap in
 * `bfsFinancingNeedFieldValidations`, the limit note appended by `useFieldPlaceholder`,
 * and the character counter resolved by `useFieldCharacterLimit`.
 */
export const BFS_CAPPED_DESCRIPTION_FIELDS: string[] = [
  GUARANTY_DESCRIPTION,
  LIQUIDITY_DESCRIPTION,
  MACHINE_DESCRIPTION,
  OFFICE_EQUIPMENT_DESCRIPTION,
  REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION,
  VEHICLE_DESCRIPTION,
];
